export default "__VITE_ASSET__Dngfkmp2__"